// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserDeleteUserIdDeleteUserResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserDeleteUserIdDeleteUserResponse.attributeTypeMap;
    }
}
AuthenticationV2UserDeleteUserIdDeleteUserResponse.discriminator = undefined;
AuthenticationV2UserDeleteUserIdDeleteUserResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=authenticationV2UserDeleteUserIdDeleteUserResponse.js.map